import warehouseRoutes from "routes/warehouse";
import containersRoutes from "routes/containers";
import inventoryRoutes from "routes/inventory";
import itemsRoutes from "routes/items";
import userRoutes from "routes/users";
import clientRoutes from "routes/clients";
import dasboardRoutes from "routes/dasboard";

const routes = [
  ...warehouseRoutes,
  ...containersRoutes,
  ...inventoryRoutes,
  ...itemsRoutes,
  ...userRoutes,
  ...clientRoutes,
  ...dasboardRoutes,
];

export default routes;
